import { moduloFixoDaUrl } from '../pages/corte/abasModulo';
import { LS_CALC_PLANILHA, resgatarDumpLsCalcPlanilha } from './calculadoraPlanilhaPersistencia';
import { authFilhaBootstrap, paramUrlApp } from './urlParamsApp';

const SESSAO_KEY = 'ade_sessao_desktop_v1';
const HEARTBEAT_INTERVAL_MS = 3000;

interface SessaoDesktop {
  token: string;
  iniciadaEm: number;
  ultimoHeartbeat: number;
}

function parseSessao(raw: string | null): SessaoDesktop | null {
  if (!raw) return null;
  try {
    const s = JSON.parse(raw) as SessaoDesktop;
    if (
      !s ||
      typeof s.token !== 'string' ||
      typeof s.ultimoHeartbeat !== 'number'
    ) {
      return null;
    }
    return s;
  } catch {
    return null;
  }
}

let sessaoMemoria: SessaoDesktop | null = null;

function persistirSessao(sessao: SessaoDesktop): void {
  sessaoMemoria = sessao;
  const json = JSON.stringify(sessao);
  try {
    localStorage.setItem(SESSAO_KEY, json);
  } catch {
    let dump: string | null = null;
    try {
      dump = localStorage.getItem(LS_CALC_PLANILHA);
    } catch {
      dump = null;
    }
    try {
      localStorage.removeItem(LS_CALC_PLANILHA);
      localStorage.setItem(SESSAO_KEY, json);
    } catch {
      /* quota */
    }
    void resgatarDumpLsCalcPlanilha(dump);
  }
}

function lerSessaoLocal(): SessaoDesktop | null {
  try {
    const doLs = parseSessao(localStorage.getItem(SESSAO_KEY));
    if (doLs) {
      sessaoMemoria = doLs;
      return doLs;
    }
  } catch {
    /* ignora */
  }
  return sessaoMemoria;
}

function gravarHeartbeatLocal(): void {
  const atual = lerSessaoLocal();
  if (!atual) return;
  atual.ultimoHeartbeat = Date.now();
  persistirSessao(atual);
}

/** Chamado após login bem-sucedido na janela principal. */
export function registrarLoginDesktop(): void {
  persistirSessao({
    token:
      typeof crypto !== 'undefined' && crypto.randomUUID
        ? crypto.randomUUID()
        : String(Date.now()),
    iniciadaEm: Date.now(),
    ultimoHeartbeat: Date.now(),
  });
}

/** Garante sessão gravada na janela principal. */
export function garantirSessaoDesktop(): string | null {
  const existente = lerSessaoLocal();
  if (existente) {
    existente.ultimoHeartbeat = Date.now();
    persistirSessao(existente);
    return existente.token;
  }
  registrarLoginDesktop();
  return lerSessaoLocal()?.token ?? sessaoMemoria?.token ?? null;
}

/** Encerra sessão (logout ou fechar janela principal). */
export function encerrarSessaoDesktop(): void {
  sessaoMemoria = null;
  try {
    localStorage.removeItem(SESSAO_KEY);
  } catch {
    /* ignora */
  }
}

let heartbeatTimer: ReturnType<typeof setInterval> | null = null;

/** Heartbeat na janela principal enquanto logada. */
export function iniciarHeartbeatSessaoDesktop(): () => void {
  if (moduloFixoDaUrl()) return () => undefined;

  garantirSessaoDesktop();

  if (heartbeatTimer) clearInterval(heartbeatTimer);
  heartbeatTimer = setInterval(gravarHeartbeatLocal, HEARTBEAT_INTERVAL_MS);

  const onFechar = () => encerrarSessaoDesktop();
  window.addEventListener('beforeunload', onFechar);

  return () => {
    if (heartbeatTimer) {
      clearInterval(heartbeatTimer);
      heartbeatTimer = null;
    }
    window.removeEventListener('beforeunload', onFechar);
  };
}

/**
 * Janela filha aberta pela principal traz ?ade_auth=1&ade_sessao=TOKEN na URL.
 * Confiamos nisso (app desktop local) — não depende de localStorage compartilhado.
 */
export function authFilhaViaUrl(): boolean {
  if (!moduloFixoDaUrl()) return false;
  const token = authFilhaBootstrap() ?? paramUrlApp('ade_sessao');
  return paramUrlApp('ade_auth') === '1' && Boolean(token && token.length > 0);
}

export const SESSAO_DESKTOP_STORAGE_KEY = SESSAO_KEY;
